import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Events } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { FCM } from '@ionic-native/fcm';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { MainPage } from '../pages/main/main';
import { InfoPage } from '../pages/info/info';
import { DatingPage } from '../pages/dating/dating';
import { LinksPage } from '../pages/links/links';
import { UrAddPage } from '../pages/ur-add/ur-add';
import { UrListPage } from '../pages/ur-list/ur-list';
import { JustinfoPage } from '../pages/justinfo/justinfo';
import { MapPage } from '../pages/map/map';
import { MaplistPage } from '../pages/maplist/maplist';
import { MapmodalPage } from '../pages/mapmodal/mapmodal';
import { ZapisPage } from '../pages/zapis/zapis';

import { GlobalsProvider } from '../providers/globals/globals';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;

  pages: Array<{ title: string, component: any, from_menu: string}>;


  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public params: GlobalsProvider,
    public events: Events,
    private fcm: FCM,
    private alertCtrl: AlertController
  ) {
    this.initializeApp();

    events.subscribe('chmenu', () => {
      this.ChangeMenu();
    });

    // used for an example of ngFor and navigation
    this.pages = [
      { title: this.params.menu_reqs, component: UrListPage, from_menu: '4' },
      { title: ' ', component: null, from_menu: '1' },
      { title: this.params.menu_info, component: MainPage, from_menu: '2' },
      { title: this.params.menu_news, component: ListPage, from_menu: '1' },
      { title: this.params.menu_med, component: UrAddPage, from_menu: '2' },
      { title: this.params.menu_urist, component: UrAddPage, from_menu: '3' },
      
      { title: this.params.menu_zapis, component: ZapisPage, from_menu: '1' },
      { title: this.params.menu_map, component: MaplistPage, from_menu: '1' },
      
      { title: ' ', component: null, from_menu: '1' },
      { title: this.params.menu_about, component: JustinfoPage, from_menu: '1' },

      { title: this.params.menu_chlang, component: HomePage, from_menu: '1' }
    ];

  }

  ChangeMenu() {
    this.pages = [
      { title: this.params.menu_reqs, component: UrListPage, from_menu: '4' },
      { title: ' ', component: null, from_menu: '1' },
      { title: this.params.menu_info, component: MainPage, from_menu: '2' },
      { title: this.params.menu_news, component: ListPage, from_menu: '1' },
      { title: this.params.menu_med, component: UrAddPage, from_menu: '2' },
      { title: this.params.menu_urist, component: UrAddPage, from_menu: '3' },

      { title: this.params.menu_zapis, component: ZapisPage, from_menu: '1' },
      { title: this.params.menu_map, component: MaplistPage, from_menu: '1' },

      { title: ' ', component: null, from_menu: '1' },
      { title: this.params.menu_about, component: JustinfoPage, from_menu: '1' },

      { title: this.params.menu_chlang, component: HomePage, from_menu: '1' }
    ];
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      //this.PushSetup();
      this.fcm.getToken().then(token => {
        console.log(token);
        this.params.push_id = token;
      });   
      
      this.fcm.onNotification().subscribe(data => {
        if (data.wasTapped) {
          //Notification was received on device tray and tapped by the user.
          //alert(JSON.stringify(data));
        } else {
          //Notification was received in foreground. Maybe the user needs to be notified.
          //alert(JSON.stringify(data));
        }
      });

      //this.PushSetup();
    });
  }

  /*PushSetup() {
    const options: PushOptions = {
      android: {
        senderID: '538468191330'
      },
      ios: {
          alert: 'true',
          badge: true,
          sound: 'false'
      }
   };
   
   const pushObject: PushObject = this.push.init(options);
   
   
   pushObject.on('notification').subscribe((notification: any) => {
    console.log('Received a notification', notification)
    if (notification.additionalData.foreground) {
        // if application open, show popup
        //alert(notification.body);
        let notifAlert = this.alertCtrl.create({
            title: notification.title,
            message: notification.message,
            cssClass: "notification",
            buttons: [
              {
                text: 'Просмотр',
                handler: () => {
                    //TODO: Your logic here
                    console.log("View alert");
                    if (notification.additionalData.page == 'newspage') {
                        this.nav.push(ListPage, {
                          id_show: notification.additionalData.id_show
                        });
                    }
                    if (notification.additionalData.page == 'reqspage') {
                      this.nav.push(UrListPage, {
                        id_show: notification.additionalData.id_show
                      });
                  }                    
                }
              },
              {
                text: 'Отмена',
                handler: () => {
                  console.log('Cancel clicked');
                }
              },              
            ]
        });

        notifAlert.present();

        setTimeout(function () {
            notifAlert.dismiss()
        }, 5000);

      } else {
        //if user NOT using app and push notification comes - NOT working, redirect to default rootPage
        if (notification.additionalData.page == 'newspage') {
          this.nav.push(ListPage, {
            id_show: notification.additionalData.id_show
          });
        }
        if (notification.additionalData.page == 'reqspage') {
          this.nav.push(UrListPage, {
            id_show: notification.additionalData.id_show
          });
        }        
        console.log("Push notification clicked");
      }
    });
   
   pushObject.on('registration').subscribe(
     (registration: any) => this.params.push_id=registration.registrationId
   );

   pushObject.on('error').subscribe(error => console.log('Error with Push plugin', error));
  }*/

  openMain(page) {
    this.nav.setRoot(MainPage);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.component != null) this.nav.push(page.component, { title: page.title, from_menu: page.from_menu });
  }
}





// WEBPACK FOOTER //
// ./src/app/app.component.ts